<template>
    <v-container>
        <v-row class="text-center my-4">

            <v-card
                outlined
                class="ma-2"
                v-for="(item, index) in items" :key="index"
                >
                <v-col cols="12">
                    <v-img
                        :src="item.icon"
                        class="rounded-xl"
                        contain
                        height="200"
                    />
                </v-col>

                <v-col class="mb-4">
                    <h1 class="display-2 font-weight-bold mb-3">
                        {{ item.name }}
                    </h1>


                    <p class="subheading font-weight-regular">
                        {{ item.desc1 }}<br>
                        {{ item.desc2 }}<br>
                        <a
                        :href="`itms-apps://apple.com/app/${item.id}`"
                        target="_blank"
                        >Appstore 다운로드</a>
                    </p>
                </v-col>

                <v-col
                    class="mb-5"
                    cols="12"
                    >
                    <h2 class="headline font-weight-bold mb-5">
                        Information Links
                    </h2>
                    <v-row justify="center">
                        <router-link class="px-2" :to="{ name: 'document', query: { type: 'service', name: item.name } }">서비스 이용약관</router-link>
                        <router-link class="px-2" :to="{ name: 'document', query: { type: 'terms', name: item.name } }">개인정보 취급방침</router-link>
                        <router-link class="px-2" :to="{ name: 'document', query: { type: 'license', name: item.name } }">오픈소스 라이센스</router-link>
                    </v-row>
                </v-col>
            </v-card>

        </v-row>
    </v-container>
</template>

<script>

export default {
    name: 'HelloWorld',
    data() {
        return {
            items: [
                {
                    name: 'toroners',
                    icon: require('@/assets/toroners.png'),
                    desc1: '토로너스 - 모든 주제의 토론이 모인 공간',
                    desc2: '궁금한 것에 대한 답을 찾는 이야기. 토로너스.',
                    id: 'id1493393322'
                },
                {
                    name: 'coinhaus',
                    icon: require('@/assets/coinhaus.png'),
                    desc1: '코인하우스 - 코인 투자 뉴스와 질문 스터디 갤러리',
                    desc2: '암호화폐 거래소 시세 비교 및 투표 게임형 커뮤니티',
                    id: 'id1555911637'
                },
                {
                    name: 'smart lotto',
                    icon: require('@/assets/lotto.png'),
                    desc1: 'SMART LOTTO - 내가 만드는 스마트한 로또',
                    desc2: '원하는 조건대로 만들어주는 똑똑한 스마트로또',
                    id: 'id1544943147'
                },
                {
                    name: '3weeks',
                    icon: require('@/assets/3weeks.png'),
                    desc1: '3weeks - 다이어트, 운동, 공부 습관 플래너',
                    desc2: '3주간의 변화. 습관을 만들고 라이프스타일을 바꾸세요.',
                    id: 'id1473374528'
                },
            ]
        }
    },
    methods: {
        aaa() {
            console.log("fhewoaingpjow")
        }
    }
}
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
